import {ToastrService} from 'ngx-toastr';
import {Orders} from '../models/order-model';
import {CaptureImageData} from '../models/captureImage-model';
import {Injectable} from '@angular/core';
import moment from 'moment';
import {LocalStorageService} from '../../local-storage.service';
import {UserAuthenticationService} from '../../services/user-authentication.service';
import {DataService} from './data.service';

@Injectable({
    providedIn: 'root',
})
export class CaptureImageService {
    constructor(private localStorage: LocalStorageService, private toast: ToastrService, private userAuthService: UserAuthenticationService, private dataService: DataService) {
    }

    public async capturedImage(event: any, order: Orders): Promise<void> {
        const images = await this.localStorage.get('capturedPhotos', 'SwissTimeEntry', false, []);
        let uploadCounter = 0;
        let imageData: CaptureImageData | undefined;
        for (let i = 0; i < event.target.files.length; i++) {
            let file = event.target.files[i];
            try {
                const blob = await this.saveImage(file);

                let fileExtension: any;
                let fileData: any;
                const index = file.type.indexOf('/');

                fileExtension = file.type.slice(index + 1);
                fileData = file;
                const user = this.userAuthService.getCurrentAuthenticatedUser();
                const lastName = user ? user.lastName : '';

                const fileName = await this.addNumberToFile(`${order.objectNumber.trim()}_${lastName}_${moment().format('DD-MM-YYYY')}_${Date.now()}.${fileExtension}`, 'fileName', order.objectID);
                const description = await this.addNumberToFile(`Handy_${lastName}`, 'description', order.objectID);
                imageData = {
                    data: blob,
                    objectID: order.objectID,
                    objectName: (order.objectSummary).trim(),
                    blob: fileData,
                    fileName,
                    description,
                    uploadDate: this.dataService.getChosenDate().toDateString(),
                    synced: false
                };
                images.push(imageData);
                await this.localStorage.add('capturedPhotos', images, 'SwissTimeEntry');
                uploadCounter++;
            } catch (fileName) {
                this.toast.error('Fehler beim Upload von ' + fileName);
            }
        }
        if (uploadCounter > 1) {
            this.toast.success(uploadCounter + ' Bilder wurden erfolgreich hinzugefügt');
        } else if (uploadCounter == 1) {
            this.toast.success(imageData?.fileName + ' wurden erfolgreich hinzugefügt');
        }
    }

    public async deleteImage(img) {
        const images = await this.localStorage.get('capturedPhotos', 'SwissTimeEntry', false, []);
        const index = images.findIndex((savedImage: CaptureImageData) => savedImage.objectID == img.objectID && savedImage.fileName == img.fileName);
        if (index < 0) {
            return false;
        }
        images.splice(index, 1);
        await this.localStorage.add('capturedPhotos', images, 'SwissTimeEntry');
        return true;
    }

    public async cleanImages() {
        let images: CaptureImageData[] = await this.localStorage.get('capturedPhotos', 'SwissTimeEntry', false, []);
        const currentDate = moment();
        const deleteAfter = this.userAuthService.getCurrentAuthenticatedUser()?.sA_DeleteDataAfter || 30;
        images = images.filter(image => image.uploadDate && currentDate.diff(moment(image.uploadDate), 'days') < deleteAfter);
        await this.localStorage.add('capturedPhotos', images, 'SwissTimeEntry');
    }

    public async getImages(): Promise<CaptureImageData[]> {
        return await this.localStorage.get('capturedPhotos', 'SwissTimeEntry', false, []);
    }

    public async editDescription(img: CaptureImageData, resultImg: any) {
        const images = await this.localStorage.get('capturedPhotos', 'SwissTimeEntry', false, []);
        const index = images.findIndex((savedImage: CaptureImageData) => savedImage.objectID == img.objectID && savedImage.fileName == img.fileName);
        if (index < 0) {
            return false;
        }
        images.splice(index, 1);
        images.push(resultImg);
        await this.localStorage.add('capturedPhotos', images, 'SwissTimeEntry');
        return true;
    }

    async addNumberToFile(fileName: string, attr: string, orderID: string): Promise<string> {
        const indexExtension = fileName.lastIndexOf('.');
        const extension = indexExtension > -1 ? fileName.slice(indexExtension, fileName.length) : '';
        const baseName = fileName.slice(0, indexExtension < 0 ? fileName.length : indexExtension);
        let newName = baseName;
        let counter = 0;

        const fI = (await this.getImages()).filter((img: CaptureImageData) => img.objectID === orderID);

        if (indexExtension >= 0) {
            newName = newName + extension;
        }

        while (!this.isUniqueName(newName, attr, fI)) {
            counter++;
            newName = `${baseName}_${counter}`;
            if (indexExtension >= 0) {
                newName = newName + extension;
            }
        }
        return newName;
    }

    public async setImageData(images: CaptureImageData[]): Promise<void> {
        await this.localStorage.add('capturedPhotos', images, 'SwissTimeEntry');
    }

    private isUniqueName(name: string, attr: string, dataSource: CaptureImageData[]): boolean {
        return dataSource.findIndex((result) => result[attr] == name) == -1;
    }

    private saveImage(file: File): Promise<any> {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        return new Promise((resolve, reject) => {
            reader.onload = (_event) => {
                resolve(_event.target?.result);
            };

            reader.onerror = (_event) => {
                reject(file.name);
            };
        });
    }
}
